import {
  FINANCIAL_SCHEMA_VERSION,
  isValidStatusForType,
  isValidTransactionType,
} from './constants';
import { isValidCivilDate } from './dates';
import {
  centsToLegacyValue,
  parseBrazilianMoneyToCents,
} from './money';

export const WRITE_PAYLOAD_ERRORS = Object.freeze({
  INVALID_AMOUNT: 'INVALID_AMOUNT',
  INVALID_DATE: 'INVALID_DATE',
  INVALID_TYPE: 'INVALID_TYPE',
  INVALID_STATUS: 'INVALID_STATUS',
});

/**
 * Constrói, sem efeitos colaterais, o payload de escrita dupla.
 * `amountInput` é a string monetária do formulário e `date` é uma data civil.
 */
export const buildTransactionWritePayload = ({
  nome,
  amountInput,
  date,
  categoria,
  tipo,
  status,
} = {}) => {
  const amountCents = parseBrazilianMoneyToCents(amountInput);
  const errors = [];

  if (amountCents === null) errors.push(WRITE_PAYLOAD_ERRORS.INVALID_AMOUNT);
  if (!isValidCivilDate(date)) errors.push(WRITE_PAYLOAD_ERRORS.INVALID_DATE);
  if (!isValidTransactionType(tipo)) errors.push(WRITE_PAYLOAD_ERRORS.INVALID_TYPE);
  if (!isValidStatusForType(tipo, status)) {
    errors.push(WRITE_PAYLOAD_ERRORS.INVALID_STATUS);
  }

  if (errors.length > 0) {
    return { ok: false, payload: null, errors };
  }

  return {
    ok: true,
    errors: [],
    payload: {
      nome,
      valor: centsToLegacyValue(amountCents),
      data: `${date}T00:00:00.000Z`,
      categoria,
      tipo,
      status,
      amountCents,
      date,
      schemaVersion: FINANCIAL_SCHEMA_VERSION,
    },
  };
};
